export const FETCH_MATCHES = 'MATCHES/FETCH_MATCHES'
export const FETCH_MATCHES_SUCCESS = 'MATCHES/FETCH_MATCHES_SUCCESS'
export const FETCH_MATCHES_FAIL = 'MATCHES/FETCH_MATCHES_FAIL'

export type FetchMatchesByTeamAction = {
  type: typeof FETCH_MATCHES
  payload: {
    sportId: string
    leagueId: string
    teamId: string
    postal: string
  }
}

export type FetchMatchesSuccessAction = {
  type: typeof FETCH_MATCHES_SUCCESS
  payload: {
    matches: {
      leagueId: string
      sportId: string
      list: any[]
    }
  }
}

export type FetchMatchesFailAction = {
  type: typeof FETCH_MATCHES_FAIL
  payload: {
    error: any
  }
}
